export default __webpack_public_path__ + "static/media/052-mouse.81abfde2.svg";